<template>
  <button
    tabindex="-1"
    class="button-date-select__button-date button-date"
    :data-date="isoDate"
    :class="{
      'button-date--disabled': isDisabled,
      'button-date--active': isSelected,
    }"
    :disabled="isDisabled"
    @click="selectDate"
  >
    <span class="button-date__weekday">{{ formattedWeekday }}</span>
    <span class="button-date__date">{{ formattedDay }}</span>
  </button>
</template>

<script setup>
import { toRefs, computed } from 'vue';
import { getDayjsByDate } from '@utils/date';

const props = defineProps({
  isoDate: {
    type: String,
    required: true,
  },
  isoDateSelected: {
    type: String,
    required: true,
  },
  isoDatesWithContent: {
    type: Array,
    required: true,
  },
});

const { isoDate, isoDateSelected, isoDatesWithContent } = toRefs(props);

const date = computed(() => getDayjsByDate(isoDate.value));

const formattedWeekday = computed(() => date.value.format('dd'));
const formattedDay = computed(() => date.value.format('DD'));

const isSelected = computed(() => isoDate.value === isoDateSelected.value);
const isDisabled = computed(
  () => !isoDatesWithContent.value.includes(isoDate.value)
);

const emit = defineEmits(['select']);
const selectDate = () => {
  emit('select', isoDate.value);
};
</script>
